import MenuIcon from '@mui/icons-material/Menu';

import { useSideMenu } from '../../../../providers/SideMenuProvider';
import { Button } from './SideMenuButton.styles';

export const SideMenuButton = () => {
  const { open } = useSideMenu();

  return (
    <Button type="button" aria-label="Open menu" onClick={open}>
      <MenuIcon />
    </Button>
  );
};
